export function FinalOutstandingSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/final-outstanding.svg'"></ng-include>`
    }
}